<template>
<div class="color-picker-section-wrapper" ref="colorpicker">
   <v-text-field
    class="pt-0"
     v-model="colorValue" 
     @focus="showPicker()"
    @input="updateFromInput"
    :label="label"
  ></v-text-field>
  <div class="color-picker-pop-wrapper" v-if="displayPicker">
 
      <div class="color-picker-wrapper">
        <v-btn
          @click="hidePicker()"
          fab 
          color="white"
          small
          class="pick-color-close"
        >
          <v-icon dark class="primary--text">check</v-icon>
        </v-btn>
        <chrome-picker :value="colors" @input="updateFromPicker" />
      </div>
 
  </div>
</div>
</template>
<script>
import { Chrome } from 'vue-color'
export default {
  components: {
    'chrome-picker': Chrome,
  },
  props: ['color', 'label'],
 data() {
		return {
			colors: {
				hex: '#000000',
			},
			colorValue: '',
			displayPicker: false,
		}
	},
	mounted() {
		this.setColor(this.color);
  },
  methods: {
		setColor(color) {
			this.updateColors(color);
			this.colorValue = color;
		},
		updateColors(color) {
			if(color.slice(0, 1) == '#') {
				this.colors = {
					hex: color
				};
			}
			else if(color.slice(0, 4) == 'rgba') {
				var rgba = color.replace(/^rgba?\(|\s+|\)$/g,'').split(','),
					hex = '#' + ((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2])).toString(16).slice(1);
				this.colors = {
					hex: hex,
					a: rgba[3],
				}
			}
		},
		showPicker() {
			document.addEventListener('click', this.documentClick);
			this.displayPicker = true;
		},
		hidePicker() {
			document.removeEventListener('click', this.documentClick);
			this.displayPicker = false;
		},
		togglePicker() {
			this.displayPicker ? this.hidePicker() : this.showPicker();
		},
		updateFromInput() {
			this.updateColors(this.colorValue);
		},
		updateFromPicker(color) {
			this.colors = color;
			if(color.rgba.a == 1) {
				this.colorValue = color.hex;
			}
			else {
				this.colorValue = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')';
			}
		},
		documentClick(e) {
			var el = this.$refs.colorpicker,
				target = e.target;
			if(el !== target && !el.contains(target)) {
				this.hidePicker()
			}
		}
	},
	watch: {
		colorValue(val) {
			if(val) {
				this.updateColors(val);
				this.$emit('input', val);
			}
		}
	},
};
</script>

<style scoped>


.color-picker-pop-wrapper{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 0;
    background: rgba(0, 0, 0, 0.85);
    width: 100%;
    height: 100%;
    z-index: 22;
}
.pick-color-close {
    position: absolute !important;
    right: 18%;
    top: 32px;
    z-index: 99;
}
</style>
<style>
.color-picker-section-wrapper .vc-chrome{
    position: absolute;
    top: 50%;
    right: 0;
    z-index: 9;
    left: 0;
    margin: 0 auto;
    transform: translateY(-50%);
}
</style>
